import Rails from '@rails/ujs'
import './alpine'
import '../controllers/life'
import '../css/life.scss'

require.context('../assets/', true, /\.(svg|jpg|png)$/)
Rails.start()
